<template>
  <section id="event-section" class="event">
    <h2 class="event__title">Event</h2>
    <InternalServerError
      v-if="isCreateServerError"
      :lang="lang"
    ></InternalServerError>
    <ul v-else class="event__list">
      <li
        class="event__list--item"
        v-for="(eventData, index) in emptyTextObj(eventListData)"
        :key="index"
      >
        <router-link
          v-if="eventData.text"
          :to="{
            path: `/${langPath}${
              $route.path.includes('company') ? 'company/' : ''
            }event/${eventData.code}`,
          }"
        >
          <div
            class="event-label"
            :style="`background-color: ${eventData.label.event_label_color};`"
          >
            <span>{{ eventData.label.event_label_name }}</span>
            <span
              class="right-triangle"
              :style="`border-color: ${eventData.label.event_label_color} transparent transparent transparent;`"
            ></span>
          </div>
          <div class="event-detail">
            <div class="title-area">
              <h4 class="event-name">
                {{ eventData.name }}
              </h4>
              <figure class="event-logo">
                <img
                  :src="`https://tmf-virtualrun.jp/images/${
                    $route.path.includes('company') ? 'company/' : ''
                  }${eventData.text.event_image_file_name}`"
                  alt=""
                  width="52px"
                  height="52px"
                />
              </figure>
            </div>
            <div class="event-date">
              {{ eventData.text.event_date }}
            </div>
            <p
              class="event-entry"
              v-html="eventData.text.event_entry_period"
            ></p>
            <ul class="event-category-label__list">
              <li class="event-category-label__list--item">
                {{ eventData.text.event_category_label }}
              </li>
            </ul>
          </div>
        </router-link>
      </li>
    </ul>
  </section>
</template>

<script>
import { RepositoryFactory } from "../../../api/RepositoryFactory";
import InternalServerError from "../../common/status/InternalServerError";
export default {
  data() {
    return {
      eventListData: [],
      isCreateServerError: false,
    };
  },
  // イベントリストを取得
  async created() {
    const EventRepository = RepositoryFactory.get("event");
    const isCompany = this.$route.path.includes("company");
    const params = {
      lang: this.lang,
      is_company_event: isCompany || "",
      company_user_name: this.userName || "",
    };
    const response = await EventRepository.getEventList(params).catch((e) => {
      if (e.response.status === 500) {
        return (this.isCreateServerError = true);
      }
    });
    this.eventListData = response.data.items;
  },
  methods: {
    emptyTextObj(eventListData) {
      return eventListData.filter((event) => event.text);
    },
  },
  props: {
    lang: {
      type: String,
    },
    langPath: {
      type: String,
    },
    userName: {
      type: String,
    },
  },
  components: {
    InternalServerError,
  },
  name: "EventList",
};
</script>

<style scoped lang="scss">
.event {
  margin: 60px 0 0 0;
  text-align: center;
  &__title {
    display: inline-block;
    line-height: 1.4;
    text-align: center;
    font-size: 60px;
    &::after {
      content: "";
      display: block;
      height: 10px;
      background: url("../../../assets/images/border/border_event.svg");
      background-size: 101%;
    }
  }
  &__list {
    padding: 0 0 0 15px;
    text-align: left;

    &--item {
      margin: 25px 0 0 0;
      border-bottom: solid 1px var(--defaultBlackColor);

      &:hover {
        background-color: var(--defaultGrayColor);
        transition-duration: 0.3s;
      }

      .event-label {
        display: inline-block;
        min-width: 109px;
        padding: 8px 10px;
        line-height: 1;
        font-size: 12px;
        font-weight: bold;
        color: var(--defaultGrayColor);
        background-color: #53996a;
        position: relative;

        .right-triangle {
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 28px 16px 0 0;
          border-color: #53996a transparent transparent transparent;
          position: absolute;
          top: 0;
          right: -16px;
        }
      }

      .event-detail {
        padding: 15px 15px 20px 0;

        .title-area {
          display: flex;
          align-items: center;

          .event-name {
            flex: 1;
            margin: 0 10px 0 0;
            font-size: 20px;
            line-height: 1.6;
          }

          .event-logo {
            padding: 5px;
            border: solid 1px var(--defaultGrayColor);
          }
        }

        .event-date {
          padding: 18px 0 0 0;
          font-size: 16px;
          font-weight: bold;
          line-height: 1.6;
          position: relative;

          &::before {
            content: "";
            width: 60px;
            height: 6px;
            position: absolute;
            top: 6px;
            background-color: var(--defaultBlackColor);
          }
        }

        .event-entry {
          margin: 17px 0 0 0;
          line-height: 1.5;
          font-size: 14px;
          font-weight: 500;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/top/EventList.vue